import React, { PureComponent } from 'react'
import { Table, OverlayTrigger, Tooltip, Button } from 'react-bootstrap'
import SuppliedModalPage from '../../../containers/masters/SuppliedModalPage'
import SimpleTreeSelect from '../../commons/simpleForm/SimpleTreeSelect'
import MapSectionsMasters from '../../../util/map-sections-masters'

class SuppliedMasters extends PureComponent {
  constructor () {
    super()
    this.state = {
      uoId: null
    }
  }

  handleOrganizedUnitChange (uoId) {
    this.setState({ uoId })
    this.props.actions.fetchSuppliedMasters(uoId)
  }

  render () {
    const {
      t, suppliedMastersList,
      actions: { deleteSuppliedModal, openSuppliedModal, recoverSuppliedModal },
      combos: { UOTreeCombo }
    } = this.props
    const secMapMasters = MapSectionsMasters.find(function (s) { return s.page === 'suppliedMastersPage' })
    const tKey = 'MASTERS.SUPPLIED_MASTERS.'
    const editTooltip = (<Tooltip id="editTooltip">{t('MASTERS.EDIT')}</Tooltip>)
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t('MASTERS.DELETE')}</Tooltip>)
    const recoverTooltip = (<Tooltip id="recoverTooltip">{t('MASTERS.RECOVER')}</Tooltip>)
    return (
      <div id='suppliedMasters' className="inner-results-panel">
        <div className="section-results-header">
          <div className="section-header-title">
            <OverlayTrigger placement="right" overlay={<Tooltip id="editProductTooltip">{`${t((this.props.hideMenu ? 'GLOBAL.TABLES.SHOW_INNER_MENU' : 'GLOBAL.TABLES.HIDE_INNER_MENU'))}`}</Tooltip>}>
              <a onClick={() => this.props.toogleInnerMenu()} className={this.props.hideMenu ? 'collapseBtn' : 'collapseBtn closeInnerMenu'}><i className={this.props.hideMenu ? 'iDocIcon-Open-inner-menu' : 'iDocIcon-Close-inner-menu'}></i></a>
            </OverlayTrigger>
            <h4>{t(`${secMapMasters.title}`)}</h4>
            {this.state.uoId && (
              <Button
                className="_Btn new"
                onClick={() => openSuppliedModal(this.state.uoId)}>
                <i className='iDocIcon-add-plus'></i>{t('MASTERS.ADD')}
              </Button>
            )}

          </div>
          <div className='filters'>
            <div className="search-form">
              <SimpleTreeSelect
                colWidth={100} // 25, 33, 50, 75, 100 default=25
                controlLabel={t(`${tKey}ORGANIZED_UNIT`)}
                placeholder={t(`${tKey}ORGANIZED_UNIT`)}
                options={UOTreeCombo}
                searchPlaceholder={t(`${tKey}ORGANIZED_UNIT`)}
                value={this.state.uoId ? this.state.uoId.toString() : null}
                onInputChange={(value) => this.handleOrganizedUnitChange(value)}
                className='dashboard-select'
                customClass='marg-top-15'
              />
            </div>
          </div>
        </div>
        <div className='section-results-body'>
          <div className={'searchResoultsContainer'}>
            <div className="table-wrapper" key="table-wrapper">
              {/* table */}
              <Table className="editable-table" hover responsive>
                <thead>
                  <tr>
                    <th>{t('MASTERS.ID')}</th>
                    <th>{t('MASTERS.NAME')}</th>
                    <th>{t('MASTERS.DESCRIPTION')}</th>
                    <th className='actions'>{t('DOSSIER_COMPONENTS.ACCESSORIES.ACTIONS')}</th>
                  </tr>
                </thead>
                <tbody>
                  {suppliedMastersList && suppliedMastersList.map((suppliedMaster, idx) => (
                    <tr key={idx} className={suppliedMaster.isDeleted ? 'is-deleted' : ''}>
                      <td>{suppliedMaster.id}</td>
                      <td>{suppliedMaster.name}</td>
                      <td>{suppliedMaster.description}</td>
                      <td className='actions'>
                        {!suppliedMaster.isDeleted ? (
                          <div>
                            <OverlayTrigger placement="left" overlay={editTooltip}>
                              <a className='_Btn accept stk o-icn ' onClick={() => openSuppliedModal(this.state.uoId, suppliedMaster.id)}>
                                <i className="iDocIcon-edit" />
                              </a>
                            </OverlayTrigger>
                            <OverlayTrigger placement="left" overlay={deleteTooltip}>
                              <a className='_Btn cancel stk o-icn ' onClick={() => { return deleteSuppliedModal(this.state.uoId, suppliedMaster.id) }}>
                                <i className="iDocIcon-delete-forever" />
                              </a>
                            </OverlayTrigger>
                          </div>
                        ) : (
                          <div>
                            <OverlayTrigger placement="left" overlay={recoverTooltip}>
                              <a className='_Btn accent stk o-icn ' onClick={() => recoverSuppliedModal(this.state.uoId, suppliedMaster.id)}>
                                <i className='iDocIcon-undo-back' />
                              </a>
                            </OverlayTrigger>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
        <SuppliedModalPage uoId={this.state.uoId}/>
      </div>
    )
  }
}

export default SuppliedMasters
